const ADD_NOTIFICATION = 'systemNotifications/ADD';
const CLEAR_NOTIFICATION = 'systemNotification/CLEAR';

export default {
  ADD_NOTIFICATION,
  CLEAR_NOTIFICATION
};
